module.exports = __webpack_public_path__ + "static/media/recept-2.3bdc0723.jpg";